import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Button, Box, CircularProgress } from '@material-ui/core';
// import useStyles from '../styles/drafts.styes';
import React from 'react';
import { HighlightOff } from '@material-ui/icons';
import {makeStyles} from '@material-ui/styles';

const useStyles = makeStyles({
        title: {
            background: '#08090a',
            padding: '4px 16px',
        
            '& .MuiTypography-root': {
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              color: '#fff'
            },
        
            '& .MuiIconButton-root': {
              color: '#fff'
            }
          },
})

const CancelModal = ({ title, content = '', loading = false, onClose, onDelete, isOpen }) => {
    const styles = useStyles();

    const handleClose = (event, reason) => {
        if (reason && reason === "backdropClick")
            return;
        onClose(event);
    }

    return (
        <Dialog
            fullWidth
            open={isOpen}
            onClose={handleClose}
        >
            <DialogTitle className={styles.title}>
                <span>{title || 'Delete'}</span>
                <IconButton disableRipple onClick={onClose}>
                    <HighlightOff />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Box height="70px">
                    {loading ? (<Box display='flex' justifyContent='center' alignItems='center' padding='1rem'>
                        <CircularProgress size={25} color="primary" />
                    </Box>) : (
                        <DialogContentText>
                            <Box padding='1rem'>
                                <Box>{content || 'Are you sure, you want to delete ?'}</Box>
                            </Box>
                        </DialogContentText>)}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button disableRipple variant="outlined"  onClick={onClose} >
                    No
                </Button>
                <Button disableRipple disabled={loading} variant="contained" color="primary" onClick={onDelete} autoFocus>
                    Yes
                </Button>
            </DialogActions>
        </Dialog>

    )
}

export default CancelModal;
